import { flags } from './flags'

// Which vendor's Approve request drawer is open (release 3.3).
//
// # WHY A SET OUTSIDE ANY COMPONENT
//
// The drawer is opened from the vendor's next step, which is drawn on the line
// and again under Details (NextStep.tsx), from the lifecycle control on the
// Profile tab's Details part, and from the send screen's refusal. Each of those is a different
// component, and the drawer belongs to the record (VendorDetail.tsx), which
// holds the vendor and its lifecycle read. A press anywhere sets the vendor's
// key here and the record, watching it, opens the one drawer: one decision
// drawer whichever door it was opened from (C9 of the 12 Oct plan). Not kept
// for the tab: a decision half made is not something a reload should reopen.
export const requestDrawer = flags()

export function openRequestDrawer(vendorId: string): void {
  requestDrawer.set(vendorId, true)
}

export function closeRequestDrawer(vendorId: string): void {
  requestDrawer.set(vendorId, false)
  // Closed, the address no longer asks for it (Back model B10: Escape and
  // Close return to the same address without ?panel=).
  if (typeof window !== 'undefined' && requestPanelAsked(window.location.hash)) {
    history.replaceState(history.state, '', withoutRequestPanel(window.location.hash))
  }
}

// The address that opens the drawer: My work's "Approve request" row links to
// #/vendor/<id>?panel=request (repo/my_work.go), a shareable address for the
// decision as Back model B7 asks of a drawer.
export function requestPanelAsked(hash: string): boolean {
  return new URLSearchParams(hash.split('?')[1] ?? '').get('panel') === 'request'
}

export function withoutRequestPanel(hash: string): string {
  const [path, query = ''] = hash.split('?')
  const q = new URLSearchParams(query)
  q.delete('panel')
  const rest = q.toString()
  return (path ?? '') + (rest ? '?' + rest : '')
}
